/* eslint-disable no-unused-vars */

import { Get, Post, Put, Delete } from "../Request";
export default {
  state: {
    Testimonials: {},
    ViewTestimonials: null,
    TestimonialsByFilter:[]
  },
  getters: {
    GetTestimonials(state) {
      return state.Testimonials;
    },
    GetTestimonialsByFilter(state) {
      return state.TestimonialsByFilter;
    },
  },
  actions: {
    async GetTestimonials({ commit }, payload) {
      return await Get(
        `Testimonial/GetTestimonials/?page=${payload.page}&pageSize=${payload.pageSize}&search=${payload.search}&filter=${payload.filters}`
      ).then((res) => {
        commit("SetTestimonials", res.data.Data);
        return res.data.Data;
      });
    },
    async GetTestimonialsByFilter({ commit }, payload) {
      try {
        const response = await Get(
          `Testimonial/GetTestimonials/?page=1&pageSize=All&search=&filter=`
        );
    
        const testimonialData = response.data.Data.Data.map((item) => ({
          submittedBy: item.CreatedBy[0].Name,
          Id:item.CreatedBy[0].Id
        }));
    
        commit("SetTestimonialsByFilter", testimonialData);
    
        return response.data.Data;
      } catch (error) {
        console.error("Error fetching testimonials:", error);
        throw error; // Re-throw the error to be caught by the caller
      }
    },

    async ToggleTestimonialVisibility({ commit }, payload) {
      return await Put(
        `Testimonial/ToggleTestimonialVisibility?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
    async UpdateTestimonial({ commit }, payload) {
      return await Put(`Testimonial/EditTestimonial`, payload).then((res) => {
        return res.data;
      });
    },
    async DeleteTestimonial({ commit }, payload) {
      return await Delete(`Testimonial/DeleteTestimonials?Id=${payload}`).then(
        (res) => {
          return res.data;
        }
      );
    },
    async ToggleTestimonialPinned({ commit }, payload) {
      return await Put(
        `Testimonial/ToggleTestimonialPinned?Id=${payload}`
      ).then((res) => {
        return res.data;
      });
    },
  },
  mutations: {
    SetTestimonials(state, payload) {
      state.Testimonials = payload;
    },
    SetTestimonialsByFilter(state, payload) {
      console.log("payload ",payload)
      state.TestimonialsByFilter = payload;
    },
    SetViewTestimonials(state, payload) {
      state.ViewTestimonials = payload;
    },
  },
};
